import { render, staticRenderFns } from "./AccountingPaymentAccount.vue?vue&type=template&id=64331bbc&"
import script from "./AccountingPaymentAccount.vue?vue&type=script&lang=js&"
export * from "./AccountingPaymentAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports